import styled from "styled-components"
import useBankAccountForm from "hooks/popup/useBankAccountForm"

import SVGIcon from "components/modules/common/SVGIcon"
import Input from "components/modules/inputs/Input"
import Checkbox from "components/modules/inputs/CheckBox/Checkbox"

function CheckBoxLabel({ onClick }) {
  return (
    <LabelText onClick={onClick}>
      (필수)개인정보 제3자 제공에 대한 안내에 동의합니다
      <ArrowIconbBlock>
        <SVGIcon name="arrow" />
      </ArrowIconbBlock>
    </LabelText>
  )
}

export default function BankAccountForm({ id, whiteBoxRef, onClose, onComplete }) {
  const { register, watch, onSubmit, getError, handleClickPolicyConsented } = useBankAccountForm(
    id,
    onClose,
    onComplete
  )

  return (
    <WhiteBox ref={whiteBoxRef}>
      <CloseBtn onClick={() => onClose(id)}>
        <SVGIcon name="close" />
      </CloseBtn>
      <Title>{`리워드 관련\n추가정보가 필요해요`}</Title>
      <Description>
        {`챌린지 상금을 받기 위해서는\n회원님의 이름, `}
        <strong>신한은행</strong>
        {` 계좌번호가\n필요합니다.`}
      </Description>
      <Form onSubmit={onSubmit} autocomplete="off">
        <Input
          label="이름 (예금주)"
          placeholder="홍길동"
          errorMsg={getError("accountHolderName")}
          {...register("accountHolderName")}
        />
        <Input
          type="text"
          label="신한 계좌번호"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder="‘-’없이 숫자만 입력"
          errorMsg={getError("accountNumber")}
          {...register("accountNumber")}
        />
        <Checkbox
          children={<CheckBoxLabel onClick={handleClickPolicyConsented} />}
          checked={watch("isPrivacyConsented")}
          {...register("isPrivacyConsented")}
          errorMsg={getError("isPrivacyConsented")}
        />
        <NotiBlock>
          <NotiText>* 신한금융투자 계좌는 상금 지급이 불가합니다</NotiText>
          <NotiText>* 이름과 신한 계좌번호가 다를경우, 상금 수령 불가</NotiText>
        </NotiBlock>
        <SubmitBtn type="submit">확인</SubmitBtn>
      </Form>
    </WhiteBox>
  )
}

const WhiteBox = styled.div`
  position: relative;
  background-color: #ffffff;
  width: calc(100vw * (280 / 375));
  border-radius: calc(100vw * (9 / 375));
  padding: calc(100vw * (42 / 375)) calc(100vw * (20 / 375)) calc(100vw * (24 / 375))
    calc(100vw * (20 / 375));
`

const CloseBtn = styled.button`
  position: absolute;
  top: calc(100vw * (17 / 375));
  left: calc(100vw * (17 / 375));
  width: calc(100vw * (14 / 375));
  height: calc(100vw * (14 / 375));

  svg {
    color: #4e4e4e;
  }
`

const Title = styled.h2`
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  line-height: calc(100vw * (24 / 375));
  text-align: center;
  white-space: pre-wrap;
  margin-bottom: calc(100vw * (15 / 375));
`

const Description = styled.p`
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (20 / 375));
  color: #4e4e4e;
  text-align: center;
  white-space: pre-wrap;
  margin-bottom: calc(100vw * (23 / 375));

  strong {
    font-weight: 700;
  }
`

const Form = styled.form`
  & > div:nth-last-of-type(2) {
    margin-top: calc(100vw * (17 / 375));
  }
`

const LabelText = styled.span`
  margin-left: calc(100vw * (5 / 375));
  font-size: calc(100vw * (11 / 375));
  font-weight: 400;
  line-height: calc(100vw * (15 / 375));
  width: calc(100vw * (193 / 375));
`

const ArrowIconbBlock = styled.div`
  display: inline-block;
  width: calc(100vw * (5 / 375));
  height: calc(100vw * (8 / 375));
  transform: translateY(calc(100vw * (-1 / 375)));
  margin-left: calc(100vw * (6 / 375));
  vertical-align: middle;
`

const NotiBlock = styled.div`
  margin-top: calc(100vw * (15 / 375));
  margin-bottom: calc(100vw * (8 / 375));
`

const NotiText = styled.p`
  font-size: calc(100vw * (11 / 375));
  font-weight: 400;
  line-height: calc(100vw * (16 / 375));
  color: #7f7f7f;
`

const SubmitBtn = styled.button`
  width: 100%;
  background-color: #ffcf19;
  border-radius: calc(100vw * (8 / 375));
  padding: calc(100vw * (14 / 375)) 0;
`
